export default __webpack_public_path__ + "static/media/poster_blash.c8674352.jpg";